
import { Component, OnInit, ViewChild, OnDestroy,EventEmitter, Input, Output } from '@angular/core';
import  * as CryptoJS from 'crypto-js';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, of, throwError } from 'rxjs';
import { AbstractBaseComponent } from '../../shared/abstract-base.component';
import * as api from '../../api';
import { APISubmitResult } from '../../api';
import { UserService } from '../../core';
import { catchError } from 'rxjs/operators';
import { AuthenticationHandlerComponent } from '../message-box-modal/authentication-handler.component';

@Component({
    selector: 'my-password-change-box-modal',
    templateUrl: 'change-password.component.html',
    styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends AbstractBaseComponent implements OnInit, OnDestroy {

    @Output() statusMessage: EventEmitter<string[]> = new EventEmitter<string[]>();
    @ViewChild('changePasswordModal', {static: true}) passwordChangeModal: ModalDirective;
    @ViewChild(AuthenticationHandlerComponent, {static: false}) public rejectModal: AuthenticationHandlerComponent;
    @Input() displayOnLoad: boolean = true;
    @Input() closeButton: boolean = false;
        
    modalConfig: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    encryptedPassword: string;
    newPassword: string = '';
    confirmPassword: string = '';
    oldPassword: string = '';
    errorDisplayMessage: string;
    isError: boolean;
    isIncorrectPasswordError: boolean; 
    isPasswordMismatch: boolean;
    passwordSubmitted: boolean = false;
    validPasswordRule: boolean = false;
    validPasswordMatch: boolean = false;
    canLeaveThisPage: boolean = true;  
    isSamePassword: boolean = false;
    isValidPasswordError: boolean;
    titleText: string;
    isPasswordHistoryViolation: boolean = false;


    constructor(private route: ActivatedRoute,
                private router: Router,
                private apiUserService: api.UserService,
                private userService: UserService) {
            super();
    }

    ngOnInit(): void {        

        this.canLeaveThisPage = this.route.snapshot.queryParams['canNavigateAway'];
      
        if(this.displayOnLoad === true){
            this.show();
        }
    }

    show(){
        this.apiUserService.userIsPasswordExpired()
            .pipe(catchError((e: any) => {
                this.rejectModal.actionErrorResponseHandler(e);
                return null;
            }))
            .subscribe((result: string) =>{ 
                if (result) {
                    let value = result.toLocaleLowerCase() === 'true' ? true : false;

                    if(value){
                        this.titleText = 'Password Expired';
                    }
                    else{
                        this.titleText = 'Change your password';
                    }
                }
            });

        this.passwordChangeModal.config = this.modalConfig;
        this.passwordChangeModal.show();
    }

    canDeactivate(): Observable<boolean> | boolean {
        return of(this.canLeaveThisPage);
    }	
   
    closeModal(modal: ModalDirective) {
        this.newPassword = '';
        this.confirmPassword = '';
        this.oldPassword = '';
        this.errorDisplayMessage = '';
        this.isIncorrectPasswordError = false;
        this.isError = false;
        this.isPasswordMismatch = false;
        this.passwordSubmitted = false;
        this.isValidPasswordError = false;
        this.isPasswordHistoryViolation = false;
        modal.hide();
        modal.ngOnDestroy();        
    }

    encryptPassword(password: string): string{
        let key = CryptoJS.enc.Utf8.parse('8080808080808080');
        let iv = CryptoJS.enc.Utf8.parse('8080808080808080');
        let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(password), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
      
        return encrypted.toString();
    }
    validatePasswordMatch(){
        if(this.newPassword !== this.confirmPassword){
            this.errorDisplayMessage = 'Passwords do not match.';
            this.isError = true;
            this.validPasswordMatch = false;
            return false;            
        }
        this.validPasswordMatch = true;
        return true;
    }
    newPasswordChange(){

        this.isValidPasswordError = false;
        this.validPasswordRule = false;
        this.isSamePassword = false;
        this.isPasswordHistoryViolation = false;           
    }
    confirmPasswordChange(){
        this.isError = false;
    }

    oldPasswordChange(){
        this.isIncorrectPasswordError = false;
    }
    
    canSave(){
        if(this.newPassword.length > 0
             && this.oldPassword.length > 0
             && this.confirmPassword.length > 0            
             && this.validPasswordRule
             && !this.isIncorrectPasswordError
             && !this.isPasswordHistoryViolation
             ){
                 return true;
            }                      
        return false;
    }
    validatePasswordRule(){      
      
        let passwordLength = this.newPassword ? this.newPassword.length: 0;
        let isValidLength = passwordLength >= 8;        
        let specialCharacterCheck =  /[*@!$#%&()^~{}]+/.test(this.newPassword);
       
        if(this.newPassword.match('\\d+')
           && specialCharacterCheck === true
           && isValidLength === true ){
               this.validPasswordRule = true;
               return this.validPasswordRule ;
        } 
        this.isValidPasswordError = true;
        return this.validPasswordRule;
    }

    savePassword(){

        this.validatePasswordMatch();       
        if(this.validPasswordMatch && this.validPasswordRule){
            let currentPassword = this.encryptPassword(this.oldPassword);
            let encNewPassword = this.encryptPassword(this.newPassword);
            let encConfirmPassword = this.encryptPassword(this.confirmPassword);
            this.passwordSubmitted = true;
            this.apiUserService.userChangePassword(currentPassword,encNewPassword,encConfirmPassword)
            .pipe(catchError((e: any) => {
                return this.rejectModal.actionErrorResponseHandler(e);
            }))                  
            .subscribe((result: APISubmitResult) =>{                
                if(result && result.Success){
                    this.apiUserService.userGetUser().subscribe(user => {
                        this.userService.refreshUser(user);

                        if(this.displayOnLoad === true){
                            this.canLeaveThisPage = true;
                            let redirect = this.route.snapshot.queryParams['redirectUrl'] || "/";
                            return this.router.navigate([redirect]);  
                        }
                        else{
                            this.closeModal(this.passwordChangeModal);
                            let successMessage: string[]= [];
                            successMessage.push('Your password has been updated.');
                            this.statusMessage.emit(successMessage);
                        }
                    });
                }
                else{
                    this.passwordSubmitted = false;                           
                    if(result.StatusCode.toString() === '3'){
                        this.isIncorrectPasswordError = true;                                                         
                    }
                    else if(result.StatusCode.toString() === '9'){
                        this.isSamePassword = true;
                        this.errorDisplayMessage = result.Message;
                    }
                    else if(result.StatusCode.toString() === '10') {
                        this.isPasswordHistoryViolation = true;
                        this.errorDisplayMessage = result.Message;
                    }
                    else{
                        this.isError = true;                 
                        this.errorDisplayMessage = result.Message;                       
                    }
                }                 
            });      

        } 
    }
}
